import React from "react";
import loadingBar from "../../assets/loading.svg";

const Loader = () => {
  return (
    <div className="flex items-center justify-center">
      <img src={loadingBar} alt="loading" />
    </div>
  );
};

export default Loader;
